// src/data/pricing.js
// Single source of truth for management fees. Change a rate here and the
// Home page, Fleet Management page and application form all update.

export const TIERS = [
  {
    key: 'exotic',
    label: 'Exotic and high-performance',
    desc: 'Exotic and high-performance cars',
    rate: 15,
  },
  {
    key: 'luxury',
    label: 'Luxury, sports and convertibles',
    desc: 'Luxury SUVs, large sedans, sports cars and convertibles',
    rate: 20,
  },
  {
    key: 'economy',
    label: 'Economy and everyday cars',
    desc: 'Economy and everyday cars',
    rate: 25,
  },
];

export const tierByKey = (key) =>
  TIERS.find((t) => t.key === key) || TIERS.find((t) => t.key === 'economy');

export const rateLabel = (tier) => `${tier.rate}%`;

// How the percentage is calculated. Edit this line if the basis changes.
export const BASIS = "your net Turo earnings (after Turo's fee)";
